import { render, staticRenderFns } from "./turnstile.vue?vue&type=template&id=74e3757e&scoped=true&"
import script from "./turnstile.vue?vue&type=script&lang=js&"
export * from "./turnstile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e3757e",
  null
  
)

export default component.exports